<template>
  <div>
    <label v-if="!disableLabel" class="selector-label" for="">{{
      ("modal_" + modal) | setText(title)
    }}</label>
    <div class="selector">
      <ul>
        <li v-for="v in val" :key="v.id">
          <span class="max-nowrap-text">
            {{ v[selectKey] }}
          </span>
          <span v-if="!disabled" @click="clearItem(v.id)"> ✕ </span>
        </li>
      </ul>
      <div @click="open" class="background" />
      <span v-if="disabled !== true" @click="open" class="ti-angle-down"></span>
    </div>
    <list-item
      :modal="modal"
      :prefix="prefix"
      :setLink="setLink"
      :simple="true"
      v-model="val"
      :pushLink="pushLink"
      :params="params"
    />
  </div>
</template>
<script>
export default {
  data: () => ({
    // val: null,
  }),

  props: {
    pushLink: {
      default: "",
    },
    setLink: {
      default: "",
    },
    title: {
      default: "",
    },
    modal: {
      default: "",
    },
    disableLabel: {
      default: false,
    },
    disabled: {
      default: false,
    },
    selectKey: {
      default: "title",
    },
    prefix: {
      default: "",
    },
    params: {
      default: function () {
        return {};
      },
    },
    value: {
      default: function () {
        return {};
      },
    },
  },
  computed: {
    val: {
      get() {
        if (this.value && this.value.id) {
          return [this.value];
        }
        return [];
      },
      set(val) {
        if (val && val.length) {
          this.$emit("input", val[0]);
        } else {
          this.$emit("input", null);
        }
      },
    },
  },
  components: {
    "list-item": () => import("../Modals/ListItem"),
  },
  methods: {
    open() {
      if (this.disabled === true) {
        return false;
      }
      this.$modal.show(`${this.modal}${this.prefix}`);
    },
    clearItem(id) {
      this.val = [...this.val].filter((item) => {
        return item.id != id;
      });
    },
  },
};
</script>
